import config from '../config'
import { authHeader } from './auth-header'

export const settingsService = {
  getSettingByKey,
  updateSetting
}

function getSettingByKey(key) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ key: key })
  }
  return fetch(`${config.apiUrl}/settings/get`, requestOptions).then(handleResponse)
}

function updateSetting(key, value) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ key: key, value: value })
  }
  return fetch(`${config.apiUrl}/settings/update`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
